import { render, staticRenderFns } from "./templateAttachment.vue?vue&type=template&id=2d2c0b04&scoped=true&"
import script from "./templateAttachment.vue?vue&type=script&lang=js&"
export * from "./templateAttachment.vue?vue&type=script&lang=js&"
import style0 from "./templateAttachment.vue?vue&type=style&index=0&id=2d2c0b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c0b04",
  null
  
)

export default component.exports